import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { OrchestrateResponse } from '../models/orchestrate-response.model';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private readonly http = inject(HttpClient);

  sendMessage(apiKey: string, data: any): Observable<OrchestrateResponse> {
    return this.http.post<OrchestrateResponse>(`${environment.API.orchestrator_chat}/orchestrate/${apiKey}`, data, /*httpOptions*/);
  }

  uploadFile(apiKey: string, sessionId: string, file: File): Observable<any> {
    const httpOptions: any = {
      params: new HttpParams().set('sessionId', sessionId),
      reportProgress: true,
      observe: 'events',
    };

    const data = new FormData();
    data.append('file', file, file.name);

    return this.http.post(`${environment.API.orchestrator_chat}/upload/${apiKey}`, data, httpOptions);
  }
}
